import { render, staticRenderFns } from "./FiscalReport.vue?vue&type=template&id=00be2736&scoped=true&"
import script from "./FiscalReport.vue?vue&type=script&lang=js&"
export * from "./FiscalReport.vue?vue&type=script&lang=js&"
import style0 from "./FiscalReport.vue?vue&type=style&index=0&id=00be2736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be2736",
  null
  
)

export default component.exports